import React from "react";

class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    if (
      error?.name === "ChunkLoadError" ||
      error?.message?.includes("Loading chunk") ||
      error?.message?.includes("ChunkLoadError")
    ) {
      return { hasError: true };
    }

    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Route render error:", error, errorInfo);

    if (
      error?.name === "ChunkLoadError" ||
      error?.message?.includes("Loading chunk")
    ) {
      console.warn(
        "Chunk loading failed. App may have been updated or dev server stopped.",
      );
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100dvh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 24,
            background: "linear-gradient(180deg, #f8fbff 0%, #eef6ff 100%)",
            color: "#0f2744",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 420,
              background: "#fff",
              borderRadius: 24,
              boxShadow: "0 12px 40px rgba(42, 125, 225, 0.12)",
              border: "1px solid #ddeeff",
              padding: 28,
              textAlign: "center",
            }}
          >
            <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>
              We hit a loading issue
            </div>
            <p style={{ fontSize: 14, lineHeight: 1.6, color: "#4a6484" }}>
              The app resources could not be loaded. This usually happens if the
              server was restarted or temporarily unavailable. Please retry to
              continue.{" "}
            </p>
            <button
              type="button"
              onClick={this.handleRetry}
              style={{
                marginTop: 18,
                border: "none",
                borderRadius: 999,
                background: "#2a7de1",
                color: "#fff",
                padding: "12px 18px",
                fontSize: 14,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Retry
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default RouteErrorBoundary;
